import React, { Component } from 'react';

class DataTableBlog extends Component {
    render() {
        return (
            <tr>
                <td>
                    {this.props.obj.id_blog}
                </td>
                <td className="display-linebreak">
                    {this.props.obj.titulo}
                </td>
                <td className="display-linebreak">
                    {this.props.obj.url_youtube}
                </td>
            </tr>
        );
    }
}

export default DataTableBlog;